(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-hero"]) return;
  try {
    
function initBrandModels(root=document){root.querySelectorAll('[data-brand-models]').forEach(panel=>{if(panel.dataset.ready)return;panel.dataset.ready='true';const input=panel.querySelector('[data-model-search]');if(!input)return;const links=[...panel.querySelectorAll('[data-model-link]')];const normalize=s=>s.toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').trim();panel.querySelector('[data-model-search-wrap]').hidden=false;input.addEventListener('input',()=>{const query=normalize(input.value);let count=0;links.forEach(link=>{link.hidden=!normalize(link.textContent).includes(query);if(!link.hidden)count++});panel.querySelector('[data-model-empty]').hidden=count>0;panel.querySelector('.brand-models__grid').scrollTop=0})})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBrandModels());else initBrandModels();document.addEventListener('shopify:section:load',e=>initBrandModels(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function initHeaderExplorer(root = document) {
  root.querySelectorAll('[data-menu-explorer]').forEach((explorer) => {
    if (explorer.dataset.ready) return;
    explorer.dataset.ready = 'true';
    const tabs = [...explorer.querySelectorAll('[data-explorer-tab]')];
    const panels = [...explorer.querySelectorAll('[data-explorer-panel]')];
    const activate = (tab) => {
      tabs.forEach((item) => {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      explorer.querySelector('.menu-explorer__body').scrollTop = 0;
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next]);
        tabs[next].focus();
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHeaderExplorer());
else initHeaderExplorer();
document.addEventListener('shopify:section:load', (event) => initHeaderExplorer(event.target));

function initNavFit(root=document){
 root.querySelectorAll('[data-nav-fit]').forEach(wrap=>{
  if(wrap.dataset.fitReady)return;wrap.dataset.fitReady='true';
  const strip=wrap.querySelector('.header__catstrip'),more=wrap.querySelector('[data-nav-more]');
  const items=[...strip.children],links=[...more.querySelectorAll('[data-more-link]')];
  const close=()=>{more.open=false;more.querySelectorAll('.nav-more__group[open]').forEach(group=>group.open=false);};
  more.querySelectorAll('.nav-more__group').forEach(group=>group.addEventListener('toggle',()=>{if(group.open)more.querySelectorAll('.nav-more__group').forEach(other=>{if(other!==group)other.open=false;});}));
  const fit=()=>{
   items.forEach(el=>el.hidden=false);links.forEach(el=>el.hidden=false);more.hidden=true;close();
   if(innerWidth<990){wrap.classList.remove('nav-fit-ready');return;}
   wrap.classList.add('nav-fit-ready');
   const gap=parseFloat(getComputedStyle(strip).gap)||0;
   const widths=items.map(el=>el.getBoundingClientRect().width);
   let total=widths.reduce((a,b)=>a+b,0)+gap*(items.length-1);
   if(total<=wrap.clientWidth)return;
   more.hidden=false;
   const available=wrap.clientWidth-more.getBoundingClientRect().width-4;
   for(let i=items.length-1;i>0&&total>available;i--){items[i].hidden=true;total-=widths[i]+gap;}
   links.forEach((link,i)=>{link.hidden=!items[i+1]?.hidden;});
  };
  more.addEventListener('toggle',()=>{if(more.open){document.querySelectorAll('[data-catdrop-trigger][aria-expanded="true"],.megamenu__trigger[aria-expanded="true"]').forEach(el=>el.click());}});
  document.addEventListener('click',e=>{if(!more.contains(e.target))close();});
  more.addEventListener('keydown',e=>{if(e.key==='Escape'){close();more.querySelector('summary').focus();}});
  new ResizeObserver(fit).observe(wrap);document.fonts.ready.then(fit);fit();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initNavFit());else initNavFit();
document.addEventListener('shopify:section:load',e=>initNavFit(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-brands"] && !Shopify.designMode) return;
  try {
    
function initBrandShelf(root=document){root.querySelectorAll('.brands-modern').forEach(section=>{if(section.dataset.shelfReady)return;section.dataset.shelfReady='true';const shelf=section.querySelector('[data-brand-shelf]');const buttons=section.querySelectorAll('[data-brand-direction]');if(!shelf)return;const update=()=>buttons.forEach(button=>{button.disabled=Number(button.dataset.brandDirection)<0?shelf.scrollLeft<2:shelf.scrollLeft+shelf.clientWidth>=shelf.scrollWidth-2});buttons.forEach(button=>button.addEventListener('click',()=>shelf.scrollBy({left:Number(button.dataset.brandDirection)*shelf.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));shelf.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update()})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBrandShelf());else initBrandShelf();document.addEventListener('shopify:section:load',e=>initBrandShelf(e.target));

  } catch(e) { console.error(e); }
})();
})();
